/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowwhenend3Inputs */

const en_aiflowwhenend3 = /** @type {(inputs: Aiflowwhenend3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ends`)
};

const de_aiflowwhenend3 = /** @type {(inputs: Aiflowwhenend3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ende`)
};

/**
* | output |
* | --- |
* | "Ends" |
*
* @param {Aiflowwhenend3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowwhenend3 = /** @type {((inputs?: Aiflowwhenend3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowwhenend3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowwhenend3(inputs)
	return de_aiflowwhenend3(inputs)
});
export { aiflowwhenend3 as "aiFlowWhenEnd" }